module.exports = __webpack_public_path__ + "media/src/img/brainstorming-3f30664fb7eac4008fe516d9cc88b182661bcad48554bddc66d238c876355561.svg";